import React from 'react';
import Modal from 'react-bootstrap/Modal';
import profileService from '../../../services/profileService';

const QRCode = require('qrcode.react');

export default class QrCode extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            code: ''
        }
    }

    componentDidMount() {
        if (!this.props.code) this.getCode()
    }
    getCode() {
        profileService.getBindingCode().then(response => {
            this.setState({
                code: response.code
            })
        }).catch(error => {
        })
    }
    render() {
        const { code } = this.state;
        return (
            <div>
                <Modal show={this.props.show} onHide={this.props.handleClose}>
                    <Modal.Header closeButton>
                        <Modal.Title>Scan QR Code</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className=" m-5 text-center" style={{background: 'white'}}>
                        <span><QRCode value={ this.props.code || code} /></span>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/modals/qrcode.js